import { render, staticRenderFns } from "./SingleSkuMarket.vue?vue&type=template&id=1decbd2f&"
import script from "./SingleSkuMarket.vue?vue&type=script&lang=js&"
export * from "./SingleSkuMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports